<script setup lang="ts">
  defineOptions({ name: 'ElList' });

  withDefaults(
    defineProps<{
      horizontal?: boolean;
      dotted?: boolean;
    }>(),
    {
      horizontal: false,
      dotted: false,
    },
  );
</script>

<template>
  <ul
    v-bind="$attrs"
    class="el-list flex"
    :class="{
      'flex-row': horizontal,
      'flex-col gap-2 max-wrap': !horizontal,
      dotted,
      'ml-5 list-disc': dotted,
    }"
  >
    <slot />
  </ul>
</template>
